import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./en.json";
import hi from "./hi.json";
import mr from "./mr.json";
import ta from "./ta.json";
import te from "./te.json";
import kn from "./kn.json";
import bn from "./bn.json";
import gu from "./gu.json";
import ml from "./ml.json";
import pa from "./pa.json";

export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिन्दी" },
  { code: "mr", label: "मराठी" },
  { code: "ta", label: "தமிழ்" },
  { code: "te", label: "తెలుగు" },
  { code: "kn", label: "ಕನ್ನಡ" },
  { code: "bn", label: "বাংলা" },
  { code: "gu", label: "ગુજરાતી" },
  { code: "ml", label: "മലയാളം" },
  { code: "pa", label: "ਪੰਜਾਬੀ" },
];

const saved = typeof window !== "undefined" ? localStorage.getItem("hk_lang") : null;

i18n.use(initReactI18next).init({
  resources: { en: { t: en }, hi: { t: hi }, mr: { t: mr }, ta: { t: ta }, te: { t: te }, kn: { t: kn }, bn: { t: bn }, gu: { t: gu }, ml: { t: ml }, pa: { t: pa } },
  lng: saved || "en",
  fallbackLng: "en",
  ns: ["t"],
  defaultNS: "t",
  interpolation: { escapeValue: false },
});

export default i18n;
